'use client'

import { useState } from "react"
import Button from "@/components/button/Button"
import ApiUtils from "@/utils/ApiUtils"
import Icon from "@/components/icon/Icon"
import Form from "@/components/form/Form"
import Field from "@/components/form/Field"
import useEventListener from "@/components/plugins/EventListener"

export default function FavoriteButton(props) {
  const {site, vin, favs, id} = props
  
  const [selected, setSelected] = useState(site.session?.vehicles?.favorites?.indexOf(vin) >= 0)
  
  useEventListener("visitor_favorites", event => {
    if (event.detail?.vehicles?.favorites) {
      setSelected(event.detail?.vehicles?.favorites.indexOf(vin) >= 0)
    }
  })
  
  const toggle = (e, remove) => {
    e.preventDefault()
    const vid = site.vid || ApiUtils.visitorId()
    ApiUtils.getRequest("/api/visitor/favorite?vid=" + vid + "&vin=" + vin + "&remove=" + (selected || remove ? 1 : 0))
    .then(data => {
      setSelected(!selected)
    })
  }
  
  return <Form id={"fav_btn_" + id} name={"Favorite Button"}>
    <Field id={"fav_fld_" + id}  type="hidden" name="vin" value={vin}></Field>
    { favs ?
    <Button theme={[ 'icon', 'floating'] } className={ 'text-primary ico-smaller'} onClick={e => toggle(e, true)} label={ 'Show My Favorites' }>
      <Icon name="x"></Icon>
    </Button>
    :
    <Button theme={[ 'icon', 'floating'] } className={ selected ? 'text-red' : 'text-primary'} onClick={e => toggle(e)} label={ 'Show My Favorites' }>
      <Icon name={ selected ? "heart-filled" : "heart" }></Icon>
    </Button>
    }
  </Form>
  
}